// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b40bb0bd","98":"06ab022a","127":"f1ae56c6","162":"f2bc0460","723":"166c5c51","725":"b3a1cba2","787":"4cdde09b","867":"2dde4c30","869":"78aa749b","972":"2c809289"}[chunkId] + ".chunk.js";
};